import React from 'react';

type Props = {
  className?: string;
  color?: string;
};

const Icon: React.FC<Props> = ({ className, color }: Props) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 15L15 1M1 1L15 15"
      stroke={color ?? '#494949'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon;
